export const requiredFieldValidation = { value: true, message: 'This field is required.' };
